import {Button, H1, TextRegular} from '@hm/fundamental'
import {mdiPlus} from '@mdi/js'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {ReactComponent as NotAvailableSvg} from '../../assets/notAvailable.svg'
import {FEATURE_NAMESPACE} from '../../consts'
import {HierarchyLevel} from '../../types'

interface ComparativeAnalysisEmptyStateProps {
  selectedLevel: HierarchyLevel
  onAdd: () => void
}

export const ComparativeAnalysisEmptyState: FC<ComparativeAnalysisEmptyStateProps> = ({
  selectedLevel,
  onAdd
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <div className="flex flex-col items-center mt-16">
      <NotAvailableSvg aria-hidden="true" />
      <H1 className="mt-6">{t('comparativeAnalysis.emptyState.heading')}</H1>
      <TextRegular className="mt-2 text-center">
        {t('comparativeAnalysis.emptyState.description')}
      </TextRegular>
      <Button
        className="mt-6"
        icon={mdiPlus}
        iconPosition="left"
        data-cy="add-hierarchy-node-button"
        onClick={onAdd}
      >
        {t('comparativeAnalysis.addNode', {
          level: t(`comparativeAnalysis.hierarchyLevel.${selectedLevel}`)
        })}
      </Button>
    </div>
  )
}
